import React, { FC } from 'react';
import Image from 'next/image';
interface ModalHeaderProps {
  closeBtnPress: () => void;
  title: string;
}
const ModalHeader: FC<ModalHeaderProps> = ({ closeBtnPress, title }) => {
  return (
    <div className={'h-4xl w-full  flex items-center justify-between flex-row pl-6 pr-4'}>
      <p className="text-lg leading-loose font-medium">{`${title}`}</p>
      <Image
        width={24}
        height={24}
        onClick={closeBtnPress}
        src={'/close-outline.svg'}
        className={'w-6 h-6 cursor-pointer'}
      />
    </div>
  );
};
export default ModalHeader;
